/** Legacy pseudo-list ids shared by Newsletter Editor and audienceSourceResolver. */

export const ALL_CONTACTS_LIST_ID = '__all_contacts__';
export const ACTIVE_DB_LIST_ID = '__active_db__';
export const INACTIVE_DB_LIST_ID = '__inactive_db__';
export const RECENT_CUSTOMERS_LIST_ID = '__recent_customers__';

/** Canonical behavioural segment list ids (Contact Manager + Newsletter Editor). */
export const CANONICAL_ACTIVE_TRADERS_LIST_ID = 'segment_active_traders';
export const CANONICAL_NEW_ACCOUNTS_LIST_ID = 'segment_new_accounts';
export const CANONICAL_DORMANT_TRADERS_LIST_ID = 'segment_dormant_traders';
export const CANONICAL_DORMANT_ONE_OFF_LIST_ID = 'segment_dormant_one_off';

/** Default signup window for recent accounts (legacy pseudo-list + account_recent). */
export const DEFAULT_RECENT_ACCOUNT_WITHIN_DAYS = 7;

export const LEGACY_PSEUDO_AUDIENCE_IDS = Object.freeze([
  ACTIVE_DB_LIST_ID,
  RECENT_CUSTOMERS_LIST_ID,
]);

/**
 * @param {string} id
 * @returns {boolean}
 */
export function isRecentSignupAudienceSourceId(id) {
  const sid = String(id || '').trim();
  return sid === RECENT_CUSTOMERS_LIST_ID || sid === CANONICAL_NEW_ACCOUNTS_LIST_ID;
}
